module.exports = __webpack_public_path__ + "static/media/add-field-button.2e3cdbc9.svg";